import { AnyAction } from 'redux';
import { forEach } from 'lodash/fp';

import { LoadingError } from '../../components/loading-error-alert/types';
import { PRODUCT_LOAD, PRODUCT_LOAD_FAIL, PRODUCT_LOAD_SUCCESS } from '../../actions/action-types';
import makeErrorSerialisable from '../../utils/make-error-serialisable';
import type { ProductType } from '../../types/product';

const initialState = {
  data: null,
  error: null,
  loading: {},
};

type ProductState = {
  data: Record<string, ProductType> | null;
  error: LoadingError | null;
  loading: Record<string, boolean>;
};

export default function productReducer(state: ProductState = initialState, action: AnyAction | {} = {}): ProductState {
  const reducers = {
    [PRODUCT_LOAD]: () => {
      const loading = { ...state.loading };

      forEach((productId) => {
        loading[productId] = true;
        // @ts-expect-error - Automatic, Please fix when editing this file
      }, action.productIds);

      return { ...state, loading };
    },
    [PRODUCT_LOAD_FAIL]: () => {
      const loading = { ...state.loading };
      // @ts-expect-error - Automatic, Please fix when editing this file
      const { productIds } = action;

      // @NOTE: Products that aren't loaded aren't handled in any meanigful way.
      forEach((productId) => {
        delete loading[productId];
      }, productIds);

      return {
        ...state,
        // @ts-expect-error - Automatic, Please fix when editing this file
        error: makeErrorSerialisable(action.error),
        loading,
      };
    },
    [PRODUCT_LOAD_SUCCESS]: () => {
      const data = { ...state.data };
      const loading = { ...state.loading };
      // @ts-expect-error - Automatic, Please fix when editing this file
      const products = action.result;

      // Update data with each Product object from the results.
      forEach((product) => {
        data[product.id] = product;
        delete loading[product.id];
      }, products);

      return {
        ...state,
        data,
        error: null, // @NOTE: It is weird that this would clear all errors
        loading,
      };
    },
  };
  // @ts-expect-error - Automatic, Please fix when editing this file
  return (reducers[action.type] ? reducers[action.type]() : state) as ProductState;
}
